import { BrowserRouter } from 'react-router-dom';
import { Shell } from '../components/Shell';
import { Dashboard } from './dashboards';
import { MODULE, meta } from '../module';
import type { Me } from '../api';

/**
 * The mockup, and deliberately not behind the login.
 *
 * Every module subdomain serves this at /preview whether or not
 * anyone is signed in. Two reasons it is open. A design that can
 * only be reviewed by someone holding an account is a design that
 * does not get reviewed, and five of the seven modules are not
 * built yet — there is nothing to protect. It reads no API and
 * touches no session, so there is no tenant data here to leak.
 *
 * The sample company is named as a sample. Nobody should be able to
 * screenshot this and mistake it for a live project.
 */
const DEMO: Me = {
  user: { id: 'preview', email: 'preview@muninpartners.com', name: 'Sample Viewer' },
  company: { id: 'preview', name: 'Northgate DC1 — sample data' },
  roles: {},
};

export function Preview({ me }: { me?: Me }) {
  const signedIn = me != null;
  return (
    <BrowserRouter>
      <Shell me={me ?? DEMO} inboxCount={0} preview signedIn={signedIn}>
        <div className="preview-bar" role="note">
          <b>Interface preview</b>
          <span>
            {signedIn
              ? 'This module is not built yet, so nothing here is your project. Every figure below is invented — it is the shape the module will take.'
              : 'Every figure on this page is invented. No project, no database, no session — this is the design system, filled in far enough to argue with.'}
          </span>
        </div>

        <div className="page-head">
          <div>
            <h1>{meta.title}</h1>
            <p>
              {meta.live
                ? 'Built and running. This dashboard is the next view to ship.'
                : 'Not built yet. This is the shape it will take.'}
            </p>
          </div>
          <span className={meta.live ? 'chip good' : 'chip'}>{meta.live ? 'Live' : 'Planned'}</span>
        </div>

        <Dashboard module={MODULE} />

        <p className="preview-foot">
          Switch modules from the bar above — each subdomain carries its own dashboard.
        </p>
      </Shell>
    </BrowserRouter>
  );
}
